import * as React from "react";
import { useTranslation } from "react-i18next";
import cx from "classnames";
import styles from "./homeSubBlocks.module.scss";
import {
  formatNumberToCmpct,
  formatNumberToEU,
} from "../../../../utils/formatDataUtil";
import CardListSkeleton from "../../../../components/elements/skeletons/cardListSkeleton/CardListSkeleton";
import { formatNumbersDefaultOptions } from "../../../../data/common";

export type IHomeSubBlocksProps = {
  statsNumberApi?: {
    activeUsers: number;
    apiKeys: number;
    dids: number;
    issuanceTemplates: number;
    issuedCredentials: number;
    verifierTemplates: number;
  };
  subBlocksData: {
    id: string;
    title: string;
    statsNumber?: number;
  }[];
  dataLoading?: boolean;
  clientsTotal?: number;
};

const HomeSubBlocks: React.FC<IHomeSubBlocksProps> = (props) => {
  const { subBlocksData, statsNumberApi, dataLoading, clientsTotal } = props;
  const { t } = useTranslation();

  return (
    <div className={styles.homeSubBlocks}>
      <p className={cx("heading6", "margin-bottom")}>
        {t("dashboard.allTotals")}
      </p>
      <div className={styles.homeSubBlocks__container}>
        {!dataLoading ? (
          statsNumberApi &&
          subBlocksData?.map((el, index) => {
            const { id, title, statsNumber } = el;
            const number =
              id === "clients"
                ? clientsTotal || 0
                : (statsNumberApi &&
                    statsNumberApi[id as keyof typeof statsNumberApi]) ||
                  0;

            return (
              <div
                key={"subBlock__" + index}
                id={id}
                className={styles.homeSubBlocks__each}
              >
                <div className={styles.homeSubBlocks__each_container}>
                  {statsNumberApi && (
                    <div
                      className={`${styles.homeSubBlocks__each_number} ${cx(
                        "heading5"
                      )}`}
                      aria-label={
                        number >= 1000 ? formatNumberToEU(number) : ""
                      }
                      aria-hidden={number >= 1000 ? false : true}
                      tooltip-position="top"
                    >
                      {formatNumberToCmpct(number, formatNumbersDefaultOptions)}
                    </div>
                  )}
                  <div
                    className={`${styles.homeSubBlocks__each_title} ${cx(
                      "bodyRegularXS"
                    )}`}
                  >
                    {t(title)}
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <CardListSkeleton
            cardsNumber={7}
            className={`${styles.homeSubBlocks__each}`}
          />
        )}
      </div>
    </div>
  );
};

export default HomeSubBlocks;
